export default __webpack_public_path__ + "static/thumb-landscape-2badbb7c8facf15b11d0b83e183243c9.jpg";